import {getEmailTemplateByIdUseCase} from '@/useCases/getEmailTemplateByIdUseCase'
import {useQuery} from '@tanstack/react-query'

export const useGetEmailTemplateDetails = (emailTemplateId?: string) => {
  const {isFetching, data, error} = useQuery({
    queryKey: ['email-template-details', emailTemplateId],
    queryFn: ({signal}) => getEmailTemplateByIdUseCase({id: emailTemplateId ?? ''}, signal),
    enabled: !!emailTemplateId,
  })

  return {
    isFetching,
    data,
    error,
  }
}
